import camelCase from 'lodash/camelCase'

import {
  getLocaleAdMappingFromSlug,
  getLocaleAdMappingFromSlugNonRedundant,
} from 'interfaces/adCategoryMapping'
import { COUNTRY_ADTAG, DEVICE_ADTAG } from 'interfaces/constants'
import { LOCALE, LocaleContentAdTagType } from 'interfaces/types'
import { capitalizeFirstLetter } from './string'

export const getAdTag = ({
  countryAdTag,
  contentAdTag,
  forceTag,
}: {
  countryAdTag: string
  contentAdTag?: LocaleContentAdTagType
  forceTag?: string
}) => {
  if (forceTag) return `/21682272649/${countryAdTag}/${forceTag}`
  if (contentAdTag) {
    if (contentAdTag.redundant) {
      return `/21682272649/${countryAdTag}/${countryAdTag}_${contentAdTag.result}`
    }
    return `/21682272649/${countryAdTag}/${contentAdTag.result}`
  }
  return `/21682272649/${countryAdTag}/ad`
}

export const getCountryAdTag = (
  locale: LOCALE | string,
  deviceInfo: {
    isMobile?: boolean
  },
) => {
  const { isMobile } = deviceInfo
  let suffix = DEVICE_ADTAG.DESKTOP
  if (isMobile) {
    suffix = DEVICE_ADTAG.MOBILE
  }
  return COUNTRY_ADTAG[locale as LOCALE] + suffix
}

export const getCategoryAdTag = (slug: string) => {
  return slug
    .split('/')
    .filter(Boolean)
    .map((slug) => capitalizeFirstLetter(camelCase(slug)))
    .join('/')
}
const getMappings = (locale: string, slug: string) => {
  const _slug = locale === 'tl-PH' ? slug.replace('fil/', '') : slug
  const processedSlug = decodeURI(_slug.split(/[?#]/)[0])
  const foundMapping = getLocaleAdMappingFromSlug(locale, processedSlug)
  const foundNonRedundantMapping = getLocaleAdMappingFromSlugNonRedundant(
    locale,
    processedSlug,
  )
  return {
    foundMapping,
    foundNonRedundantMapping,
  }
}
export const getLocaleCategoryAdTag = (
  locale: string,
  slug: string,
  alternatives?: string[],
): LocaleContentAdTagType | undefined => {
  // remove query string, remove hash, decode URI
  const foundSlug = [slug, ...(alternatives || [])].find((s) => {
    const mappings = getMappings(locale, s)
    return mappings.foundMapping || mappings.foundNonRedundantMapping
  })
  const { foundMapping, foundNonRedundantMapping } = getMappings(
    locale,
    foundSlug || '',
  )
  if (!foundMapping && !foundNonRedundantMapping) {
    const _slug = locale === 'tl-PH' ? slug.replace('fil/', '') : slug
    const processedSlug = decodeURI(_slug.split(/[?#]/)[0])
    return {
      result: getCategoryAdTag(processedSlug),
      redundant: true,
    }
  }
  return {
    result: foundMapping || foundNonRedundantMapping || '',
    redundant: !!foundMapping,
  }
}
export const getCategorySlugFromArticleSlug = (slug: string): string => {
  const slugs = slug.split('/').filter(Boolean)
  slugs.pop()
  return slugs.join('/')
}

export const setGlobalTargeting = (adSlot: any) => {
  const slugSplit = window.location.pathname.split(/[-/]/).filter(Boolean)
  if (slugSplit.length > 0) {
    adSlot.setTargeting('Keyword_URL', slugSplit)
  }
}
